import CustomCarousel from "components/CustomCarousel";
import LazyLoadImage from "components/LazyLoadImage";
import MediaPreview from "components/MediaPreview/MediaPreview";
import { ReactComponent as CloseIcon } from "assets/img/icons/cancel.svg";
import peerRecog from "assets/img/peer_recognition.png";
import checkIn from "assets/img/CheckIn.png";
import pollIm from "assets/img/poll.png";
import statistics from "assets/img/statistics.png";
import list from "assets/img/list.png";
import watercooler from "assets/img/watercooler.png";
import { Modal } from "react-responsive-modal";
import brightIdea from "assets/img/brighidea.png";

function AppOverviewData({ openOverViewM, handleClose }) {
  const overViewData = [
    {
      id: 1,
      src: peerRecog,
      heading: "Wall of fame",
      description:
        "Build a thankful and recognition based culture. Wall of Fame makes it easy to recognize your colleagues for all the things they do to help you and your whole team.",
    },
    {
      id: 2,
      src: brightIdea,
      heading: "Bright Ideas",
      description:
        "Innovation is a process. And it stats with an idea. Our Bright Ideas allows you to share your idea while it is still a concept - and engage your teams to help you take it to the next level.",
    },
    {
      id: 3,
      src: pollIm,
      heading: "Poll",
      description:
        "We make it easy to get feedback from your team. Take polls asynchronously or live - watch responses in real time. And our polls improve your teams participation and engagement.",
    },
    {
      id: 4,
      src: watercooler,
      heading: "Water-Cooler",
      description:
        "Watercooler is a virtual communication gateway, users from different locations can join meetings through watercooler.",
    },
    {
      id: 5,
      src: list,
      heading: "To Do List",
      description:
        "Assign tasks, capture followups, set reminders, send company principles, share document - so many uses for our lists and tasks - and we made it simple and easy to use.",
    },
    {
      id: 6,
      src: checkIn,
      heading: "Check In",
      description:
        'Check in with your team - we recommend doing this on a weekly basis - and keep track of your team using our "Happiness Meter." ',
    },
    {
      id: 7,
      src: statistics,
      heading: "Statistics",
      description:
        "Check how your team is doing with real time statistics to show how well your team is engaging and participating. We can also work with you to generate deeper insights through our analytics and reporting. Contact us for more information.",
    },
  ];

  return (
    <Modal
      classNames={{
        modalContainer: "modalContainer",
        modal: "overViewModal",
      }}
      open={openOverViewM}
      showCloseIcon={false}
      onClose={handleClose}
    >
      <div>
        <div className="modalHeaderOverview">
          <div className="modalHeading">App OverView</div>
          <div className="modalCloseIcon">
            <CloseIcon className="closeIcon" onClick={handleClose} />
          </div>
        </div>
        <div className="modalContentOverview">
          <CustomCarousel
            disableSwipeByMouse={true}
            swipeTreshold={60}
            itemsToShow={1}
            speed={400}
          >
            {overViewData.map((image) => (
              <div key={image.id} className="overViewContainer">
                <MediaPreview
                  attachment={image.src}
                  type={"image"}
                  teamPage={false}
                >
                  <LazyLoadImage
                    image={image.src}
                    key={image.src}
                    alt={image.id}
                    imageClassName={"overViewImage"}
                  />
                </MediaPreview>
                <div className="overViewFooter">
                  <p className="overViewHeading">{image.heading}</p>
                  <span className="overViewDescription">
                    {image.description}
                  </span>
                </div>
              </div>
            ))}
          </CustomCarousel>
        </div>
      </div>
    </Modal>
  );
}

export default AppOverviewData;
